
/* Bloom Nav GA4 Click Tracking v1
   Fires: gtag('event', 'menu_click', { menu_level, menu_item, menu_parent, menu_url })
   Works with both desktop mega-menu and mobile accordion nav */
(function() {
  function track(label, level, parent, url) {
    if (typeof gtag === 'function') {
      gtag('event', 'menu_click', {
        menu_item: label,
        menu_level: level,
        menu_parent: parent || '(top)',
        menu_url: url || '',
        event_category: 'navigation'
      });
    }
  }

  function attachTracking() {
    /* Desktop mega-menu links */
    document.querySelectorAll('.htb-mega-menu__heading, .htb-mega-menu__link').forEach(function(el) {
      if (el.dataset.gaTracked) return;
      el.dataset.gaTracked = '1';
      el.addEventListener('click', function() {
        var text = (el.textContent || '').trim();
        var href = el.getAttribute('href') || '';
        /* Determine parent */
        var col = el.closest('.htb-mega-menu__column');
        var heading = col ? col.querySelector('.htb-mega-menu__heading') : null;
        var parent = heading ? heading.textContent.trim() : '';
        var level = el.classList.contains('htb-mega-menu__heading') ? 'category' : 'product';
        if (text === parent) parent = '(top)';
        track(text, level, parent, href);
      });
    });

    /* Desktop top-level nav links (Impact theme) */
    document.querySelectorAll('header .mega-menu-disclosure summary, header [is="dropdown-disclosure"] summary').forEach(function(el) {
      if (el.dataset.gaTracked) return;
      el.dataset.gaTracked = '1';
      el.addEventListener('click', function() {
        var text = (el.textContent || '').replace(/[\n\r]/g, '').trim();
        track(text, 'top', '(top)', '');
      });
    });

    /* Mobile sidebar — top-level buttons */
    var sidebar = document.getElementById('header-sidebar-menu');
    if (sidebar) {
      sidebar.querySelectorAll('.panel li > button, .panel li > a').forEach(function(el) {
        if (el.dataset.gaTracked) return;
        el.dataset.gaTracked = '1';
        el.addEventListener('click', function() {
          var text = (el.querySelector('span:first-child') || el).textContent.trim();
          var href = el.getAttribute('href') || '';
          track(text, 'top', '(top)', href);
        });
      });

      /* Mobile accordion sub-items */
      sidebar.querySelectorAll('.bloom-product-link').forEach(function(el) {
        if (el.dataset.gaTracked) return;
        el.dataset.gaTracked = '1';
        el.addEventListener('click', function() {
          var text = (el.textContent || '').trim();
          var href = el.getAttribute('href') || '';
          /* Find parent accordion header */
          var acc = el.closest('.bloom-acc');
          var parentLi = acc ? acc.previousElementSibling : null;
          var parent = parentLi ? (parentLi.querySelector('span:first-child') || parentLi).textContent.trim() : '';
          track(text, 'product', parent, href);
        });
      });

      /* Mobile accordion sub-headers */
      sidebar.querySelectorAll('.bloom-sub-header').forEach(function(el) {
        if (el.dataset.gaTracked) return;
        el.dataset.gaTracked = '1';
        el.addEventListener('click', function() {
          var text = (el.textContent || '').trim();
          var acc = el.closest('.bloom-acc');
          var parentLi = acc ? acc.previousElementSibling : null;
          var parent = parentLi ? (parentLi.querySelector('span:first-child') || parentLi).textContent.trim() : '';
          track(text, 'category', parent, '');
        });
      });
    }
  }

  /* Run on load and after any DOM changes (drawer opens, accordion expands) */
  document.addEventListener('DOMContentLoaded', attachTracking);
  new MutationObserver(function() {
    setTimeout(attachTracking, 100);
  }).observe(document.body, { childList: true, subtree: true });
  
  /* Also run after a short delay for dynamic content */
  setTimeout(attachTracking, 1000);
  setTimeout(attachTracking, 3000);
})();
